import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import {
  AuthenticationService,
  ConfigurationService,
} from "@/shared-module/services";

@Component({ templateUrl: "connect.component.html" })
export class ConnectComponent {
  idToken: string;
  ltiRegistration: any;
  loading: boolean;
  errorMessage: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private configurationService: ConfigurationService,
  ) {
    this.idToken = this.route.snapshot.queryParamMap.get("idToken");

    this.loading = true;
    this.errorMessage = "";
    const thisObject = this;
    this.authenticationService.logout();
    this.authenticationService.connect(this.idToken).subscribe(
      (data: any) => {
        thisObject.loading = false;
        if (data.isSuccess) {
          if (data.displayDemoPopup) {
            this.configurationService.setDemoPopup(true);
          }
          thisObject.router.navigate([data.firstPageUrl]);
        } else if (data.ltiRegistration) {
          this.ltiRegistration = data.ltiRegistration;
        } else {
          thisObject.errorMessage = data.errorMessage;
        }
      },
      (error) => {
        thisObject.errorMessage = error;
        thisObject.loading = false;
      },
    );
  }
}
